<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a [routerLink]="returnLink">
            <h3>Vacaciones períodos de prioridad /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? 'Editar período de prioridad' : 'Añadir período de prioridad' }}</h2>
            </div>
        </a>
    </div>
</div>

<form [formGroup]="priorityPeriodForm" class="content">
    <!-- Exercise field -->
    <h4>Ejercicio:</h4>
    <mat-form-field appearance="outline" id="exercise-form-field">
        <mat-select placeholder="Selecciona un ejercicio" formControlName="exercise">
            @for (exercise of exercises; track exercise.id) {
                <mat-option [value]="exercise.id">{{ exercise.name }}</mat-option>
            }
        </mat-select>
        @if (priorityPeriodForm.get('exercise')?.invalid && priorityPeriodForm.get('exercise')?.touched) {
        <mat-error>
            El ejercicio es requerido
        </mat-error>
        }
    </mat-form-field>

    <!-- Min years worked field -->
    <h4>Años mínimos trabajados:</h4>
    <mat-form-field appearance="outline" id="min-years-form-field">
        <input type="number" matInput placeholder="Años mínimos" formControlName="min_years_worked" min="0">
        @if (priorityPeriodForm.get('min_years_worked')?.invalid && priorityPeriodForm.get('min_years_worked')?.touched) {
        <mat-error>
            @if (priorityPeriodForm.get('min_years_worked')?.hasError('required')) {
                Los años mínimos son requeridos
            }
            @if (priorityPeriodForm.get('min_years_worked')?.hasError('min')) {
                Los años mínimos no pueden ser negativos
            }
        </mat-error>
        }
    </mat-form-field>

    <!-- Date range fields -->
    <h4>Período:</h4>
    <div style="display: flex; gap: 20px; flex-direction: column;">
        <div style="display: flex; gap: 20px;">
            <mat-form-field appearance="outline" style="width: 20% !important;">
                <mat-label>Fecha inicio</mat-label>
                <input matInput [matDatepicker]="pickerStart" formControlName="start_date" placeholder="Fecha inicio">
                <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
                @if (priorityPeriodForm.get('start_date')?.invalid && priorityPeriodForm.get('start_date')?.touched) {
                <mat-error>
                    La fecha de inicio es requerida
                </mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 20% !important;">
                <mat-label>Fecha fin</mat-label>
                <input matInput [matDatepicker]="pickerEnd" formControlName="end_date" placeholder="Fecha fin">
                <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerEnd></mat-datepicker>
                @if (priorityPeriodForm.get('end_date')?.invalid && priorityPeriodForm.get('end_date')?.touched) {
                <mat-error>
                    La fecha de fin es requerida
                </mat-error>
                }
            </mat-form-field>
        </div>
        @if (priorityPeriodForm.hasError('dateRangeInvalid') && (priorityPeriodForm.get('start_date')?.touched || priorityPeriodForm.get('end_date')?.touched)) {
        <div class="error-message">
            La fecha de fin debe ser mayor o igual a la fecha de inicio
        </div>
        }
    </div>

    <br><br><br>
    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()"
            [disabled]="isSubmitting || priorityPeriodForm.invalid">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
            }
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</form>
